import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, FormGroup, FormControlLabel, TextField, Button, Checkbox } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from 'react-hook-form';
import { ApplicationDataAPI } from '../../API/ApplicationDataAPI';
import { RfiDataAPI } from '../../API/RfiDataAPI';

import UseStyles from "./UseStyles";

function NewRfi(props) {
  const { app } = props;
  const { register, handleSubmit, errors } = useForm();
  const classes = UseStyles();
  const [rfi, setRfi] = useState({});
  const [saving, setSaving] = useState(false);
  const [currentAction, setCurrentAction] = useState("");
  const [salesReps, setSalesReps] = useState(props.broker.agency_persons);
  const [rfiOtherReason, setRfiOtherReason] = useState("");
  const [rfiReasons, setRfiReasons] = useState([]);

  useEffect(() => {
    (async () => {
      RfiDataAPI.rfiReasonsPicklist().then(
        (data) => {
          setRfiReasons(data);
        }
      )
    })();
  }, []);

  const handleChekbocChange = (event) => {
    let tempReps = salesReps;
    tempReps.forEach(rep => {
      if (event.target.value === rep.email) {
        rep.isSelected = event.target.checked;
      }
    });
    setSalesReps(tempReps)
  }

  const saveRfi = async () => {

    let selected_reps = [];
    salesReps.forEach(rep => {
      if (rep.isSelected) {
        selected_reps.push(rep.email);
      }
    });

    let rfiData = {
      application_id: app.id,
      rfi_reason: rfi.reason === "Other" ? rfiOtherReason : rfi.reason,
      detail: rfi.details,
      sales_rep: selected_reps.join(),
      is_done: false,
      rfi_from: rfi.from ?? "App RFI",
    }
    await RfiDataAPI.addRfi(rfiData, "ALL", app.locked_by_email);
  }

  const holdApplication = async () => {
    await ApplicationDataAPI.updateApplicationWithAction(app, { action: "hold" }, "ALL", app.locked_by_email);
  }

  const onSubmit = async (data) => {
    try {
      setSaving(true);
      setCurrentAction("Saving RFI......");
      let rfiData = await saveRfi();

      setCurrentAction("Putting application on hold......");
      await holdApplication();
      props.onRfiSaved();
    } catch (e) {
      console.log(e);
      alert("error while saving data.");
      setCurrentAction("");
      setSaving(false);
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TableContainer component={Paper}>
        <Table className="uniqueName" aria-label="simple table">
          <TableBody>
            {/* <TableRow >
                        <TableCell colSpan="2" align="left">New RFI</TableCell>
                    </TableRow> */}
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                Broker
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  size="small"
                  disabled
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={app.broker_account_name}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                Account Manager
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  size="small"
                  disabled
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={app.account_manager_id}
                />
              </TableCell>
            </TableRow>
            {/* <TableRow >
                        <TableCell align="right" className={classes.data_cell}>RFI Requester</TableCell>
                        <TableCell align="left" className={classes.data_cell}>
                            &nbsp;
                    </TableCell> 
                    </TableRow>*/}
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                Application Status
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  size="small"
                  disabled
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={app.status}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                From *
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  select
                  size="small"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={rfi.from ?? "App RFI"}
                  onChange={(e) => setRfi({ ...rfi, from: e.target.value })}
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="App RFI">APP Rfi</option>
                  <option value="Ng Proxy">Ng Proxy</option>
                </TextField>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                Sales Rep *
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <FormGroup>
                  {salesReps.map((row, index) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          name="chkRfiSalesrep"
                          inputRef={register({ required: true })}
                          color="primary"
                          value={row.email}
                          onChange={(e) => handleChekbocChange(e)}
                        />
                      }
                      label={row.name}
                    />
                  ))}
                </FormGroup>
                {errors.chkRfiSalesrep && (
                  <span style={{ color: "red" }}>Sales rep is required</span>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                Reason *
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  select
                  name="ddlRfiReason"
                  size="small"
                  variant="outlined"
                  style={{ width: "100%" }}
                  value={rfi.reason}
                  inputRef={register({ required: true })}
                  error={Boolean(errors && errors.ddlRfiReason)}
                  onChange={(e) => setRfi({ ...rfi, reason: e.target.value })}
                  SelectProps={{
                    native: true,
                  }}
                >
                  <option value="">Select</option>
                  {rfiReasons?.map((row, index) => (
                    <option key={index} value={row}>
                      {row}
                    </option>
                  ))}
                </TextField>
                {rfi.reason === "Other" && (
                  <TextField
                    style={{ marginTop: "5px" }}
                    fullWidth={true}
                    size="small"
                    variant="outlined"
                    placeholder="RFI Reason"
                    value={rfiOtherReason}
                    onChange={(e) => setRfiOtherReason(e.target.value)}
                  />
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right" className={classes.data_cell}>
                RFI Comment *
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <TextField
                  size="small"
                  name="txtRfiComment"
                  variant="outlined"
                  inputRef={register({ required: true })}
                  error={Boolean(errors && errors.txtRfiComment)}
                  multiline
                  rows={5}
                  rowsMax={4}
                  style={{ width: "100%" }}
                  value={rfi.details}
                  onChange={(e) =>
                    setRfi({ ...rfi, details: e.target.value })
                  }
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="left" className={classes.data_cell}>
                &nbsp;
              </TableCell>
              <TableCell align="left" className={classes.data_cell}>
                <Button
                  size="small"
                  type="submit"
                  variant="contained"
                  disabled={saving}
                  color="primary"
                  startIcon={
                    saving ? <CircularProgress size={20} /> : <SaveIcon />
                  }
                >
                  {" "}
                  Submit RFI{" "}
                </Button>
                {saving ? (
                  <span style={{ marginLeft: 5 }}>
                    <strong>{currentAction}</strong>
                  </span>
                ) : null}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </form>
  );
}

export default NewRfi
